import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({
    submitting: false,
    error: null,
    success: false
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, error: null, success: false });

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("access_key", "3ae4be16-a81b-4ab6-852c-daa49e912460");
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("message", formData.message);
      formDataToSend.append("subject", `[Autokosmetyka.pro] Nowa wiadomość od ${formData.name}`);

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error('Wystąpił błąd podczas wysyłania wiadomości');
      }

      setStatus({
        submitting: false,
        error: null,
        success: true
      });

      // Reset form
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    } catch (error) {
      setStatus({
        submitting: false,
        error: error.message,
        success: false
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {status.success && (
        <div className="p-3 bg-green-500/20 text-green-200 rounded">
          Wiadomość została wysłana pomyślnie!
        </div>
      )}

      {status.error && (
        <div className="p-3 bg-red-500/20 text-red-200 rounded">
          {status.error}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-200">
            Imię i nazwisko
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="mt-1 block w-full rounded-lg bg-white/10 border-gray-600 text-white placeholder-gray-400 focus:ring-primary-500 focus:border-primary-500"
            placeholder="Jan Kowalski"
          />
        </div>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-200">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mt-1 block w-full rounded-lg bg-white/10 border-gray-600 text-white placeholder-gray-400 focus:ring-primary-500 focus:border-primary-500"
            placeholder="jan@example.com"
          />
        </div>
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-gray-200">
          Wiadomość
        </label>
        <textarea
          id="message"
          name="message"
          rows={4}
          value={formData.message}
          onChange={handleChange}
          required
          className="mt-1 block w-full rounded-lg bg-white/10 border-gray-600 text-white placeholder-gray-400 focus:ring-primary-500 focus:border-primary-500"
          placeholder="Napisz do nas..."
        />
      </div>

      <button
        type="submit"
        disabled={status.submitting}
        className={`
          w-full py-3 px-4 rounded-lg text-white font-medium
          ${status.submitting
            ? 'bg-primary-600/50 cursor-not-allowed'
            : 'bg-primary-600 hover:bg-primary-700'
          }
          transition-colors duration-300
          focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500
        `}
      >
        {status.submitting ? (
          <span className="flex items-center justify-center">
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Wysyłanie...
          </span>
        ) : (
          'Wyślij wiadomość'
        )}
      </button>
    </form>
  );
};

export default ContactForm;
